import { getCookie } from "functions";
import Router from "next/router";

export function handleRouter(props) {
  let lang = getCookie("lang") || "en";

  let { href, as } = props;
  href = href === "/" ? "" : href;

  var _href = lang ? "/[lang]" : "";
  var _as = lang ? `/${lang}` : "";

  href = `${_href}${href}`;
  as = as ? `${_as}${as}` : `${_as}${href}`;

  // Prevent navigation to the same URL - with more robust checks
  if (typeof window !== "undefined") {
    // Get current path and normalize it
    const currentPath = window.location.pathname;
    // Normalize both paths for comparison
    const normalizedCurrentPath = currentPath.replace(/\/$/, ""); // Remove trailing slash if any
    const normalizedTargetPath = as.replace(/\/$/, ""); // Remove trailing slash if any

    if (normalizedCurrentPath === normalizedTargetPath) {
      // If we're trying to navigate to the same page, don't do anything
      return;
    }

    // Additional check to handle query params properly when using Router
    if (Router.pathname === href && Router.asPath === as) {
      return;
    }
  }

  Router.push(href, as);
}
